import { Link } from "react-router-dom";
import BarmaidLogo from "./BarmaidLogo";
import { useT } from "../i18n";
import { appUrl } from "../lib/appUrl";

export default function Footer() {
  const translate = useT();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-[var(--border-subtle)] bg-surface/60">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 py-12 sm:px-6 md:flex-row md:items-start md:justify-between">
        <div>
          <BarmaidLogo size={28} />
          <p className="mt-3 max-w-xs text-sm text-muted-foreground">{translate("footerTagline")}</p>
        </div>

        <nav className="flex flex-col gap-3 text-sm" aria-label="Footer">
          <a
            href={appUrl("/admin/login")}
            className="font-medium text-foreground transition hover:text-accent"
          >
            {translate("footerLogin")}
          </a>
          <Link to="/contact" className="text-muted-foreground transition hover:text-foreground">
            {translate("footerContact")}
          </Link>
          <Link to="/privacy" className="text-muted-foreground transition hover:text-foreground">
            {translate("footerPrivacy")}
          </Link>
          <a href="#" className="text-muted-foreground transition hover:text-foreground">
            {translate("footerTerms")}
          </a>
        </nav>
      </div>

      <div className="border-t border-[var(--border-subtle)] px-4 py-4 sm:px-6">
        <p className="mx-auto max-w-6xl text-center text-xs text-muted-foreground">
          {translate("footerCopyright", { year })}
        </p>
      </div>
    </footer>
  );
}
